<h3 class="ui header light user-step-title">Course Summary</h3>

<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.text"></app-loading>
</div>

<ng-template #loaded>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>

  <ng-template #noErrors>

    <div class="summary" id="course-summary">

      <div class="summary-description">
        In this section, review the information you entered about your course in the previous steps.
      </div>

      <div class="summary-description">
        After you verify all the information:
        <ul>
          <li>click <b>Submit button below</b> to complete the process of mapping your course.</li>
          <li>Click the <b>Download as PDF</b> button to download your course report.</li>
        </ul>

      </div>

      <div class="pdf-button">
        <button class="ui button primary mini" (click)="generatePdf()" [disabled]="">
          <i class="download icon"></i>Download as PDF</button>
      </div>

      <div>


        <!-- Assessment -->

        <ng-container *ngIf="assessmentFormat.isEnabled">

          <h5 class="ui attached header" [ngClass]="{top: userSteps[0].name == 'assessment'}">
            Student Assessment Methods
          </h5>
          <div class="ui attached segment">
            <div *ngIf="assessmentFormat.isEnabled">
              <div class="summary-section-description">
                Student assessment methods used in this course are listed below.
              </div>

              <app-user-step-summary-assessment [assessmentFormat]="assessmentFormat" [courseId]="courseId">

              </app-user-step-summary-assessment>

            </div>

            <div *ngIf="!assessmentFormat.isEnabled">
              <div class="summary-section-description">
                <div class="ui message">
                  Student assessment methods are not collected in this curriculum review.
                </div>
              </div>
            </div>
          </div>

        </ng-container>

        <!-- TLA -->

        <ng-container *ngIf="tlaFormat.isEnabled">

          <h5 class="ui attached header" [ngClass]="{top: userSteps[0].name == 'tla'}">
            Teaching and Learning Activities
          </h5>

          <div class="ui attached segment">
            <div *ngIf="tlaFormat.isEnabled">
              <div class="summary-section-description">
                Teaching and learning activities for this course.
              </div>

              <app-user-step-summary-tla [tlaFormat]="tlaFormat" [courseId]="courseId">

              </app-user-step-summary-tla>


            </div>

            <div *ngIf="!tlaFormat.isEnabled">
              <div class="summary-section-description">
                <div class="ui message">
                  Teaching and learning activities are not collected in this curriculum review.
                </div>
              </div>
            </div>

          </div>

        </ng-container>


        <!-- Course Outcome List -->

        <h5 class="ui attached header" [ngClass]="{top: userSteps[0].name == 'outcome'}">
          Course Outcomes
        </h5>

        <div class="ui attached segment">

          Course outcomes for this course are listed here.

          <div class="summary-section-description">

            <app-course-outcome-list [courseId]="courseId" [assessmentFormat]="assessmentFormat"
              [tlaFormat]="tlaFormat">
            </app-course-outcome-list>

          </div>

        </div>

        <!-- Course Outcomes Details -->


        <ng-container *ngIf="outcomeQuestions.length > 0">

          <h5 class="ui attached header">
            Course Outcome Related Questions
          </h5>

          <div class="ui attached segment" [ngClass]="{top: userSteps[0].name == 'question'}">

            <div class="summary-section-description">

              <app-course-outcome-details [reviewId]="review.id" [courseId]="courseId" [questions]="outcomeQuestions">
              </app-course-outcome-details>

            </div>

          </div>

        </ng-container>


        <!-- Outcome Maps -->

        <h5 class="ui attached header">
          Outcome Maps
        </h5>

        <div class="ui attached segment">

          <div class="summary-section-description">

            <div class="user-step-instruction">
              This chart shows the alignment of course outcomes to program-level learning outcomes.
              Program-level learning outcomes and the mapping scale are listed below the chart.
            </div>

            <!-- <div class="open-in-full">
              <button class="ui button basic mini" (click)="openFullScreen()">
                Open in fullscreen
              </button>
            </div> -->

            <app-user-step-summary-outcome-maps *ngIf="courseOutcomes.length > 0 && programOutcomes.length> 0"
              [programOutcomes]="programOutcomes" [programOutcomeCategories]="programOutcomeCategories"
              [assessmentFormat]="assessmentFormat" [tlaFormat]="tlaFormat" [courseId]="courseId"
              [courseOutcomes]="courseOutcomes" [reviewId]="review.id">
            </app-user-step-summary-outcome-maps>

            <!-- PLO -->

            <div class="ui divider"></div>

            <div class="subsection program-outcomes">
              <div class="subsection-title">
                <span>Program-level Learning Outcomes</span>
              </div>


              <app-course-summary-plo [programOutcomes]="programOutcomes"
                [programOutcomeCategories]="programOutcomeCategories">

              </app-course-summary-plo>


            </div>


            <div class="ui divider"></div>

            <!-- Mapping Scale -->

            <div class="subsection scale-table">
              <div class="subsection-title">Mapping scale</div>
              <div>The following are the mapping scales used to indicate the degree to which a program-level learning
                outcome
                is addressed by a particular course outcome.</div>

              <app-mapping-scale [levels]="levels">

              </app-mapping-scale>

            </div>

          </div>

        </div>

        <!-- Course Questions -->

        <ng-container *ngIf="courseQuestions.length > 0">

          <h5 class="ui attached header">
            Additional Questions about the Course
          </h5>

          <div class="ui attached segment">

            <app-additional-questions [reviewId]="review.id" [courseId]="courseId" [relatingTo]="relatingTo"
              [questions]="courseQuestions">

            </app-additional-questions>

          </div>

        </ng-container>



        <!-- Analysis Questions -->


        <ng-container *ngIf="courseAnalysisQuestions.length > 0">

          <h5 class="ui attached header">
            Analysis Questions
          </h5>


          <div class="ui attached segment">

            <div class="description">When analyzing the information in your course report, you may want to consider the
              following:</div>

            <ul>
              <li *ngFor="let courseAnalysisQuestion of courseAnalysisQuestions"> {{ courseAnalysisQuestion.question }}
              </li>
            </ul>

          </div>

        </ng-container>


      </div>

    </div>

    <!-- 

    <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
    </app-action-errors> -->


    <div class="button-area" *ngIf="userCourse.status != 'Submitted'">
      <a id="submit">
        <button class="ui button tiny submit-button primary" (click)="submitCourse()"
          [disabled]="userCourse.isArchived">
          Submit</button>
      </a>
    </div>


    <div class="button-area" *ngIf="userCourse.status == 'Submitted'">
      <div class="already-submitted">
        This course information has been submitted.
      </div>
    </div>



  </ng-template>



</ng-template>

<!-- Submit dialog -->
<app-dialog [dialog]="dialog" [updating]="dialogUpdating" (closeDialog)="closeDialog()"
  (submitDialog)="proceedSubmit()">
</app-dialog>
<!-- End Submit Dialog -->


<!-- Thank you dialog -->
<div class="thank-you-modal modal-window" *ngIf="shouldShowThankYouForm"
  [ngClass]="{'show': shouldShowThankYouForm, 'hide': !shouldShowThankYouForm}">

  <div class="modal-window-content">

    <div class="thanks-title">Thank you 😀</div>
    <div class="thanks-description">
      Your course information has been submitted.
    </div>

    <div class="thanks-close-button">
      <button class="ui button tiny primary" (click)="clearAll()">Close</button>
    </div>

  </div>

</div>
<!-- End Thank you dialog -->


<div class="full-screen modal-window" [ngClass]="{'show': shouldShowFullScreen, 'hide': !shouldShowFullScreen}">


  <div class="content">
    <div class="close-icon">
      <i class="close icon" (click)="closeFullScreen()"></i>
    </div>

    <div class="outcome-map-title">Outcome Maps</div>

    <div>
      <app-user-step-summary-outcome-maps *ngIf="courseOutcomes.length > 0" [programOutcomes]="programOutcomes"
        [programOutcomeCategories]="programOutcomeCategories" [assessmentFormat]="assessmentFormat"
        [tlaFormat]="tlaFormat" [courseId]="courseId" [courseOutcomes]="courseOutcomes" [reviewId]="review.id">
      </app-user-step-summary-outcome-maps>

    </div>


  </div>


</div>


<!-- PDF dialog -->
<div class="download-modal modal-window" *ngIf="shouldShowPdfScreen"
  [ngClass]="{'show': shouldShowPdfScreen, 'hide': !shouldShowPdfScreen}">




  <div class="modal-window-content">

    <i class="close icon" (click)="cancelDownload()"></i>

    <div class="download-title">Download</div>


    <div *ngIf="pdfGenerating">
      Generating a PDF file...
    </div>

    <div *ngIf="!pdfGenerating">
      <div *ngIf="pdfSuccess">
        The PDF file is ready!
      </div>
      <div class="ui message negative" *ngIf="!pdfSuccess">
        There was an error while creating a PDF file. Please try again later.
      </div>

    </div>


    <div class="download-button">
      <button class="ui button  primary" (click)="downloadPdf()" [disabled]="pdfGenerating || !pdfSuccess"
        [ngClass]="{'loading': pdfGenerating}">
        <i class="download icon"></i>Download</button>
    </div>

  </div>

</div>
<!-- End PDF dialog -->